import { render, staticRenderFns } from "./CreateUserTags.vue?vue&type=template&id=6b564d6a"
import script from "./CreateUserTags.vue?vue&type=script&lang=js"
export * from "./CreateUserTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports